var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",class:_vm.elClasses,attrs:{"ontouchmove":"_handleTouchmove"}},[_c('router-view',{ref:"page"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }